export default "__VITE_ASSET__i$_iIRg2__"